import React, { useEffect } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';

import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import { ID, PACKAGE_NAME } from './constants.tsx';

const FireDevopsTargetingEvents = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	// This tenant context value is set only when the user signs up for a devops instance.
	const isDevopsSite = getTenantContext_DEPRECATED_DO_NOT_USE().isDevopsProjectCreationScenario;

	useEffect(() => {
		if (isDevopsSite) {
			fireOperationalAnalytics(createAnalyticsEvent({}), 'devopsSite visited');
		}
	}, [createAnalyticsEvent, isDevopsSite]);

	return null;
};

const WithAnalyticsFireDevopsTargetingEvents = withAnalyticsEvents()(FireDevopsTargetingEvents);

const SafeWithAnalyticsFireDevopsTargetingEvents = (): React.JSX.Element => (
	<ErrorBoundary id={ID} packageName={PACKAGE_NAME}>
		<WithAnalyticsFireDevopsTargetingEvents />
	</ErrorBoundary>
);

export default SafeWithAnalyticsFireDevopsTargetingEvents;
